// Format tanggal untuk tampilan.
// Tanggal tanpa jam (YYYY-MM-DD) diformat dengan memecah string, BUKAN
// new Date(...), supaya tidak bergeser hari karena zona waktu.

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;
const DISPLAY_DATE = /^\d{2}-\d{2}-\d{4}$/;

/**
 * "2026-01-01" -> "01-01-2026". Nilai yang sudah DD-MM-YYYY (mis. dari
 * POST /Dos/List) dikembalikan apa adanya. Kosong/tidak valid -> "-".
 */
export const formatDateOnly = (value?: string | null) => {
  if (!value) return "-";

  const text = String(value).trim();
  if (DISPLAY_DATE.test(text)) return text;

  const match = DATE_ONLY.exec(text);
  if (!match) return "-";

  const [, year, month, day] = match;
  return `${day}-${month}-${year}`;
};

/**
 * Waktu (ISO dengan jam, mis. createdAt/reviewed_at) -> tanggal & jam lokal
 * "dd/mm/yyyy hh.mm". Ini memang titik waktu, jadi dikonversi ke zona lokal.
 * Kosong/tidak valid -> "-".
 */
export const formatDateTime = (value?: string | null) => {
  if (!value) return "-";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return `${date.toLocaleDateString("id-ID")} ${date.toLocaleTimeString("id-ID", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};
